import {
  booleanAttribute,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { MaterialModule } from '@fullyops/shared/material.module';

/**
 * Shell for a panel hosted in the right-hand form sidenav through
 * SidenavPortalBridgeService. It owns the header, the close button and the scroll
 * behaviour; everything else is projected. The title is rendered verbatim. Content marked
 * `panel-footer` is kept below the scrolling body, for actions that must stay in view.
 *
 * Layout contract: the component hosting the shell must pass the drawer's height
 * through:
 *
 *   :host { display: flex; flex-direction: column; flex: 1 1 auto; min-height: 0; }
 */
@Component({
  selector: 'fo-side-panel',
  standalone: true,
  imports: [MaterialModule],
  templateUrl: './side-panel.component.html',
  styleUrl: './side-panel.component.scss',
})
export class SidePanelComponent {
  @Input({ required: true }) title = '';
  @Input() closeAriaLabel = 'Close';
  /**
   * For a panel pushed on top of another (SidenavPortalBridgeService.pushPortal): the header leads with a
   * back arrow instead of ending with a close button. Either emits `closed`.
   */
  @Input({ transform: booleanAttribute }) nested = false;
  @Input() backAriaLabel = 'Back';
  /** Named `closed` because the linter disallows both `onClose` and `close`. */
  @Output() closed = new EventEmitter<void>();
}
